import { combineReducers } from 'redux';
import list from './list';
import uploadMedia from './uploadMedia';
import forms from './forms';
import mediaViewer from './mediaViewer';
import mediaExport from './mediaExport';
import documentPages from './documentPages';
import uploadMediaFromUrl from './uploadMediaFromUrl';

export default combineReducers({
  list,
  forms,
  uploadMedia,
  mediaViewer,
  mediaExport,
  documentPages,
  uploadMediaFromUrl,
});
